export const tokens = {
  rewardToken: {
    token: "GUILD",
    address: "0x83e9f223e1edb3486f876ee888d76bfba26c475a",
    decimals: 18,
  }
};
